import { pageTitleStyles } from "@solveindustrial/Overrides/Widgets/Basic/PageTitle";

pageTitleStyles.pageTitle = {
    ...pageTitleStyles.pageTitle,
    variant: "h1",
};
